import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { PiggyBank, Heart, Shield, Home, Scale, Car, Briefcase, Calendar, ChevronDown, ChevronUp } from 'lucide-react';
import { services } from '../data/mock';
import { CALENDLY_URL } from '../data/mock';

const iconMap = {
  PiggyBank: PiggyBank,
  Heart: Heart,
  Shield: Shield,
  Home: Home,
  Scale: Scale,
  Car: Car,
  Briefcase: Briefcase
};

const ServicesSection = () => {
  const [expandedCards, setExpandedCards] = useState({});

  const toggleCard = (id) => {
    setExpandedCards(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const handleBooking = (serviceTitle) => {
    if (CALENDLY_URL && CALENDLY_URL !== 'PLACEHOLDER_CALENDLY_URL') {
      window.open(CALENDLY_URL, '_blank', 'width=800,height=800');
    } else {
      alert('Calendly-Link wird noch konfiguriert. Bitte kontaktieren Sie uns direkt.');
    }
  };

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-blue-50 via-white to-blue-50/50 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-300/20 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Unsere Leistungen
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Umfassende Beratung für alle Ihre Versicherungsbedürfnisse - digital oder persönlich vor Ort
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[service.icon];
            const isExpanded = expandedCards[service.id];
            
            return (
              <Card
                key={service.id}
                className="transition-all duration-300 border-blue-100 bg-white/80 backdrop-blur-sm hover:shadow-xl"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl flex items-center justify-center mb-4 shadow-lg">
                    <Icon className="text-white" size={28} />
                  </div>
                  <CardTitle className="text-xl text-blue-900">{service.title}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  {/* Collapsed state - nur erste 100 Zeichen */}
                  {!isExpanded && (
                    <p className="text-slate-600 text-base">
                      {service.description.substring(0, 100)}...
                    </p>
                  )}
                  
                  {/* Expanded state - vollständiger Text mit Absatzformatierung */}
                  {isExpanded && (
                    <div className="text-slate-600 text-base space-y-3 animate-slide-down">
                      {service.description.split('\n\n').map((paragraph, idx) => (
                        <p key={idx} className="leading-relaxed">{paragraph}</p>
                      ))}
                    </div>
                  )}
                  
                  {/* Toggle Button */}
                  <Button
                    onClick={() => toggleCard(service.id)}
                    variant="outline"
                    className="w-full border-blue-200 text-blue-700 hover:bg-blue-50 transition-all duration-300"
                  >
                    {isExpanded ? (
                      <>
                        Weniger anzeigen
                        <ChevronUp className="ml-2" size={18} />
                      </>
                    ) : (
                      <>
                        Mehr erfahren
                        <ChevronDown className="ml-2" size={18} />
                      </>
                    )}
                  </Button>
                  
                  {/* Termin buchen Button - nur wenn expanded */}
                  {isExpanded && (
                    <Button
                      onClick={() => handleBooking(service.title)}
                      className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105 animate-slide-down"
                    >
                      <Calendar className="mr-2" size={18} />
                      Jetzt Termin buchen
                    </Button>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;